import { replace } from "@remix-run/react"
import { asc, desc, like, or, ValueOrArray } from "drizzle-orm"
import { SQLiteColumn } from "drizzle-orm/sqlite-core"
import { s } from "node_modules/vite/dist/node/types.d-aGj9QkWt"

export const fieldSort = (
  orderField: string,
  orderBy: "ascending" | "descending"
): string => {
  return `${orderBy === "descending" ? "-" : ""}${orderField}`
}

export const defaultListQuery = {
  page: 1,
  limit: 12,
  sort: fieldSort("created_at", "descending"),
  search: "",
}

export type ListQuery<T = Record<string, string | number>> = {
  page: number
  limit: number
  search: string
  sort: string
  province: string
  status: string
  district: string
  sector: string
} & T


export function getListQuery<T>(
  request: Request,
  defaultQuery?: Partial<ListQuery<T>>
): ListQuery<T> {
  const searchParams = new URL(request.url).searchParams

  const query: Record<string, string | number> = {}

  // keys that must always remain strings (even if they look like numbers)
  const alwaysStringKeys = ["province", "status", "sector","district"]

  for (const key of searchParams.keys()) {
    const value = searchParams.get(key)

    if (value == null) continue

    if (alwaysStringKeys.includes(key)) {
      // keep as string
      query[key] = value
    } else {
      // auto-detect number or string
      query[key] = isNaN(Number(value)) ? value : Number(value)
    }
  }

  if (defaultQuery) {
    Object.keys(defaultQuery).forEach(key => {
      query[key] = query[key] || (defaultQuery as any)[key]
    })
  }

  query.page = query.page || defaultListQuery.page
  query.limit = query.limit || defaultListQuery.limit
  query.search = query.search || defaultListQuery.search
  query.sort = query.sort || defaultListQuery.sort

  return query as ListQuery<T>
}

export const paginate = (page: number, limit: number) => {
  return {
    offset: (Number(page) - 1) * Number(limit),
    limit: Number(limit)
  }
}

export const filterSearch = (search: string, columns: SQLiteColumn[]) => {
  if (!search) {
    return or()
  }
  return or(...columns.map(column => like(column, `%${search}%`)))
}

export const sortColumn = (sort: string, map: Record<string, SQLiteColumn>) : any[] => {
  if (!sort) return []
  const column = sort.replace(/^-/, "")
  const order = sort.startsWith("-") ? "descending" : "ascending"

  if (column in map) {
    if (order === "ascending") {
      return [asc(map[column])]
    } else {
      return [desc(map[column])]
    }
  }

  return []
}
